export default __webpack_public_path__ + "static/media/footer.278f26e6.png";